import type { HourMinute } from './graphql/scalars'

export const visitTimes: HourMinute[] = []
for (let h = 7; h < 24; h++) {
  for (let m = 0; m < 60; m += 30) {
    visitTimes.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}` as HourMinute)
  }
}
visitTimes.push('24:00' as HourMinute)
